module.exports = __webpack_public_path__ + "img/del.5f354a18.png";